var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#020400",
    fillRule: "evenodd",
    d: "m29,23h-6c0-4.418-3.582-8-8-8-4.419,0-8,3.582-8,8h-6c-0.552,0-1,0.447-1,1 0,0.553 0.448,1 1,1h28c0.553,0 1-0.447 1-1 0-0.553-0.447-1-1-1zm-20,0c0-3.313 2.686-6 6-6 3.313,0 6,2.687 6,6h-12zm6-12c0.553,0 1-0.447 1-1v-4c0-0.553-0.447-1-1-1-0.552,0-1,0.447-1,1v4c0,0.553 0.448,1 1,1zm10.363,4.888l3.185-2.016c0.44-0.278 0.59-0.896 0.336-1.377-0.254-0.482-0.816-0.647-1.256-0.369l-3.185,2.016c-0.44,0.278-0.59,0.895-0.336,1.377 0.254,0.482 0.817,0.647 1.256,0.369zm-23.911-2.016l3.185,2.016c0.44,0.278 1.003,0.113 1.256-0.369 0.254-0.482 0.103-1.099-0.336-1.377l-3.185-2.016c-0.44-0.278-1.002-0.113-1.256,0.369-0.255,0.482-0.104,1.099 0.336,1.377z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.f691c6a6152af769d0937eec902144d6.svg";
export { ForwardRef as ReactComponent };